module.exports = __webpack_public_path__ + "img/pic2.d67a47db.jpg";